__turbopack_context__.v({
  "optionList": "UtFasW_optionList",
  "question": "UtFasW_question",
  "title": "UtFasW_title",
});
